/**
 * Cliente HTTP da feature de resumos (F12 Wave 8).
 * Endpoint: GET /api/v1/summaries
 */

import { httpClient } from '../../shared/http/client';

export interface SummaryListItem {
  meeting_id: string;
  meeting_title: string | null;
  created_at: string;
  sentiment_score: number | null;
  preview: string;
}

export interface SummariesListResponse {
  items: SummaryListItem[];
  cursor: string | null;
}

export async function listSummaries(q: string, cursor?: string): Promise<SummariesListResponse> {
  const params = new URLSearchParams();
  if (q.trim().length > 0) params.set('q', q.trim());
  if (cursor !== undefined && cursor.length > 0) params.set('cursor', cursor);

  const qs = params.toString();
  const url = qs.length > 0 ? `/api/v1/summaries?${qs}` : '/api/v1/summaries';

  const res = await httpClient.get<SummariesListResponse>(url);
  return res.data;
}
